import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { fetchCombiWerkbakken } from '../services/fetchCombiWerkbakken'

export { useCombiWerkbakken }

const queryKey = 'combiwerkbakken'

const useCombiWerkbakken = () => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: () => fetchCombiWerkbakken(),
    queryKey: [queryKey],
    enabled: hasPermissions,
  })

  return {
    data: data || [],
  }
}
